import React, { Component } from 'react'
import './scss/App.scss'
import Router from './componentes/Router.jsx'

class App extends Component {
	render() {
		return (
			<Router />
		)
	}
}

export default App